import React, { memo, useMemo } from 'react';
import Chart from 'react-apexcharts';
import { max } from 'lodash';
import colors from '../../styles/_colors.module.scss';
import './lineChartCustomStyles.css';

export default memo(function LineChart(props) {
    for (let i=0; i<props.data.length; i++) props.data[i] = parseInt(props.data[i]);
    const maxValue = max(props.data);
    const maxY = useMemo(() => maxValue+1<5 ? 5 : maxValue+1 );
    const tickAmount = useMemo(() => maxY<=10 ? max([5,maxY]) : 10 );
    const chartOptions = {
        options: {
            plotOptions: { line: { curve: 'smooth' } },
            chart: {
                animations: { speed: 1500 },
                toolbar: {
                    tools: {
                        download: false,
                        selection: true,
                        zoom: '<img src="./icons/zoom_in.svg" width="20">',
                        zoomin: '<img src="./icons/plus_circle.svg" width="20">',
                        zoomout: '<img src="./icons/minus_circle.svg" width="20">',
                        pan: '<img src="./icons/grab.svg" width="20">',
                        reset: '<img src="./icons/home.svg" width="20">'
                    },
                    autoSelected: 'zoom'
                },
            },
            colors: [colors.contentBackground],
            stroke: {
                width: 5,
                curve: 'smooth'
            },
            xaxis: {
                type: props.type,
                labels: {
                    style: { colors: colors.contentBackground },
                    formatter: value => {
                        const categoryTime = new Date(value);
                        const hours = categoryTime.getHours();
                        const minutes = categoryTime.getMinutes();
                        const minutesString = minutes === 0
                            ? `${minutes}0`
                            : minutes < 10
                                ? `0${minutes}`
                                : minutes;
                        const seconds = categoryTime.getSeconds();
                        const secondsString = seconds === 0
                            ? `${seconds}0`
                            : seconds < 10
                                ? `0${seconds}`
                                : seconds;

                        return `${hours}:${minutesString}:${secondsString}`;
                    }
                },
                axisBorder: { color: colors.contentBackground },
                axisTicks: { color: colors.contentBackground },
                tooltip: { enabled: false },
                crosshairs: { stroke: { color: colors.selectedGreen } },
                categories: props.categories
            },
            tooltip: { x: { format: 'dd MMM HH:mm:ss' } },
            yaxis: {
                tickAmount: tickAmount,
                min: 0,
                max: maxY,
                labels: { style: { color: colors.contentBackground } },
                axisBorder: { color: colors.contentBackground },
                axisTicks: { color: colors.contentBackground },
            },
            markers: {
                size: 4,
                opacity: 1,
                colors: [colors.contentBackground],
                strokeWidth: 0,
                hover: { size: 7 }
            }
        },
        series: [{
            name: props.dataName,
            data: props.data
        }]
    };

    return <Chart options={chartOptions.options} series={chartOptions.series} type="line" height={props.height} />;
}, (prevProps, nextProps) =>
        prevProps.categories === nextProps.categories &&
        prevProps.data === nextProps.data &&
        prevProps.dataName === nextProps.dataName &&
        prevProps.height === nextProps.height &&
        prevProps.type === nextProps.type
);
